export default __webpack_public_path__ + "static/media/tag.47d4f7af.svg";